import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import DemoWalkthrough from './components/DemoWalkthrough';
import BeforeAfter from './components/BeforeAfter';
import Pricing from './components/Pricing';
import Testimonial from './components/Testimonial';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import StickyBottomCTA from '../../components/feature/StickyBottomCTA';
import { useSEO, generateSchemaOrg, generateLocalBusinessSchema } from '../../utils/seo';

export default function HomePage() {
  // Homepage SEO with comprehensive structured data
  const homepageSchema = [
    generateLocalBusinessSchema(),
    generateSchemaOrg('WebSite', {
      name: 'MTA Planner Pro',
      url: 'https://mtaplannerpro.com',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://mtaplannerpro.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string'
      }
    })
  ];

  useSEO({
    title: 'MTA Planner Pro - AI-Powered MTA Quote Software Australia | Generate Quotes in 5 Minutes',
    description: 'Generate accurate MTA quotes in under 5 minutes with AI-powered material take-offs. Built for Australian tradies. Upload plans, auto-calculate materials, export branded quotes instantly. Save 5+ hours per week. Free 14-day trial.',
    keywords: 'MTA quote software Australia, tradie quoting software, AI material take-off, construction estimating software, trade business software, invoice generator Australia, building quote calculator, Australian construction software',
    structuredData: homepageSchema
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Features />
      <HowItWorks />
      <DemoWalkthrough />
      <BeforeAfter />
      <Pricing />
      <Testimonial />
      <FAQ />
      <CTA />
      <Footer />
      <StickyBottomCTA />
    </div>
  );
}